module.exports = __webpack_public_path__ + "static/media/newten_10.6d6a8aae.png";